module.exports = __webpack_public_path__ + "static/jean-80fe55304731b934210b5dcf4627bca7.jpg";